import * as st from './player.module.scss'
import { PLAYER_ELEMENT_ID } from './config'


type Overflow = 'hidden' | 'visible'

const setBodyOverflow = (overflow: Overflow) => {
  document.getElementsByTagName('body')[0].style.overflow = overflow
}

const setPlayerClass = (className: string) => {
  document.getElementById(PLAYER_ELEMENT_ID)!.className = className
}

st

export const defaultView = {
  open: () => {
    setPlayerClass('dv-player-fullscreen')
    setBodyOverflow('hidden')
  },
  close: () => {
    setPlayerClass('')
    setBodyOverflow('visible')
  }
}
